'use client';

import type { HtmlProps } from '@/core/types';

import React from 'react';

import { Box, Container, Typography } from '@/components/ui';

export default function HtmlBlock({
  title,
  titleTag = 'h2',
  description,
  data,
  className = '',
}: HtmlProps) {
  return (
    <section className={`relative ${className}`}>
      <Container>
        <Box className="flex items-start flex-col max-w-4xl mx-auto">
          {title && (
            <Typography
              variant="h2"
              component={titleTag}
              className="uppercase text-2xl lg:text-4xl mb-2 lg:mb-[48px] font-bold text-primary-dark"
            >
              {title}
            </Typography>
          )}

          {description && (
            <Box
              className="mb-2 md:text-2xl [&>p]:mb-4 [&>ul]:list-disc [&>ul]:pl-4 [&>h2]:text-primary-dark"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}

          {data && (
            <Box
              className="mb-2 md:text-md [&>p>a]:underline [&>p]:font-extralight [&>ul>li]:font-extralight [&>ul]:mb-4 [&>p]:mb-6 [&>ul]:list-disc [&>ul]:pl-4 [&>h2]:mt-10 [&>ul>li>b]:font-medium [&>p>b]:font-medium [&>h2]:text-primary-dark [&>h2]:font-black [&>h2]:uppercase lg:[&>h2]:text-2xl [&>h2]:mb-8"
              dangerouslySetInnerHTML={{ __html: data }}
            />
          )}
        </Box>
      </Container>
    </section>
  );
}
